/* v8 ignore start */
type TAppEnv = "development" | "staging" | "production";

const APP_ENV = (process.env.NEXT_PUBLIC_APP_ENV as TAppEnv) || "development";

const settings = {
  development: {
    iframeParentUrl: "https://rails.local.mxenvironments.com:3000",
    apiBaseUrl: "https://rails.local.mxenvironments.com:3000",
    internalUrl: "https://memories.local.mxenvironments.com:3001",
  },
  staging: {
    iframeParentUrl: "https://www.app.mxenvironments.com",
    apiBaseUrl: "https://www.app.mxenvironments.com",
    internalUrl: "https://www.memories.mxenvironments.com",
  },
  production: {
    iframeParentUrl: "https://www.mixbook.com",
    apiBaseUrl: "https://www.mixbook.com",
    internalUrl: "https://www.memories.mixbook.com",
  },
};

const appSettings = settings[APP_ENV];

export const AppConfiguration = {
  environment: APP_ENV,
  codeVersion: process.env.NEXT_PUBLIC_VERSION,
  iframeParentUrl: appSettings.iframeParentUrl,
  apiBaseUrl: appSettings.apiBaseUrl,
  internalUrl: appSettings.internalUrl,
  rollbarServerToken: process.env.NEXT_PUBLIC_ROLLBAR_POST_SERVER_ITEM_ACCESS_TOKEN,
};
/* v8 ignore stop */
